import { useEffect, useState } from 'react';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $messageCentreStore, $profileFeatureStore } from '@lib/store';
import { useRouteHook } from '@shared/hooks';
import { cn, PaletteUtils, RoutePaths } from '@shared/utils';
import { MessageThread, NewMessage } from './widgets';
import { MessageTemplates } from '@widgets';
import { NoData, PageContainer, Spinner } from '@shared/widgets';

export const MessageCenterPage = () => {
  const { navigate } = useRouteHook();

  const profileFeatureStore = useUnit($profileFeatureStore.store);
  const messageCentreStore = useUnit($messageCentreStore.store);

  const [isFirstLoading, setIsFirstLoading] = useState<boolean>(true);

  const { t } = useTranslation('messageCenter');

  const isLoading = isFirstLoading && messageCentreStore.firstLoading;
  useEffect(() => {
    if (!profileFeatureStore.data?.messages.viewOrReply) navigate(RoutePaths.dashboard.onNavigate());

    //Auto update threads every 60sec
    $messageCentreStore.events.getThreads();
    const intervalId = setInterval(() => {
      if (isLoading) return;
      setIsFirstLoading(false);
      $messageCentreStore.events.getThreads();
    }, 60000);

    return () => clearInterval(intervalId);
  }, []);

  if (!profileFeatureStore.data?.messages?.viewOrReply) return null;
  return (
    <PageContainer title={t('title')} header={t('header')}>
      {messageCentreStore.loading && <Spinner position />}
      <main className={cn('flex gap-8', PaletteUtils.isVcfcPalette && 'max-md:flex-col max-md:gap-4')}>
        <div className='flex flex-1 flex-col gap-4'>
          <MessageTemplates />
          {isLoading ? (
            <Spinner />
          ) : (
            <div className='flex flex-col gap-2'>
              {messageCentreStore.data?.map((thread) => <MessageThread key={thread.groupId} thread={thread} />)}
            </div>
          )}
          {!isLoading && (!messageCentreStore.data || messageCentreStore.data.length === 0) ? <NoData /> : null}
        </div>
        <NewMessage className={cn('h-fit w-80 flex-none', PaletteUtils.isVcfcPalette && 'max-md:w-full')} />
      </main>
    </PageContainer>
  );
};
